// Global error handler (specs/00-standards.md §6.4). Logs to the console and, when analytics is
// loaded, sends a `tool_error` event with ONLY { tool, category, message_code }.
import { isUserError } from './errors';
import { logToolError } from '../firebaseConfig';

export interface ToolErrorReport {
  tool: string;
  category: string;
  message_code: string;
}

/** Builds the analytics payload. Never includes the error message, stack or any user input. */
export function buildErrorReport(err: unknown, tool: string): ToolErrorReport {
  if (isUserError(err)) return { tool, category: err.category, message_code: err.code };
  return { tool, category: 'unexpected', message_code: 'unhandled' };
}

/** Slug of the tool on the current page, taken from the path ("/json-parser" → "json-parser"). */
export function currentToolSlug(pathname: string = window.location.pathname): string {
  return pathname.replace(/^\/+|\/+$/g, '') || 'home';
}

let installed = false;

/** Call once at startup. */
export function installGlobalErrorHandler(send: (r: ToolErrorReport) => void = logToolError): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  window.addEventListener('error', (ev) => {
    console.error('[window error]', ev.error ?? ev.message);
    send(buildErrorReport(ev.error, currentToolSlug()));
  });
  window.addEventListener('unhandledrejection', (ev) => {
    console.error('[unhandled rejection]', ev.reason);
    send(buildErrorReport(ev.reason, currentToolSlug()));
  });
}
